import React from "react";
import { useState, useEffect } from "react";

import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";

import httpService from "services/httpService";
import Spacer from "components/Common/Spacing";
import moment from "moment";
import ProvinceCustomerPieChart from "components/Common/ProvinceCustomerPieChart";
import BarChartCustomer from "components/Common/BarChartCustomer";

const ReportCustomer = () => {
  const [dataCharts, setDataCharts] = useState([]);

  useEffect(() => {
    getDataSummarizeCustomer();
  }, []);

  const getDataSummarizeCustomer = async () => {
    try {
      const summarizeLeadUrl = "/parse/functions/summary-lead";
      const body = {
        dateFrom: moment().startOf("year").format("YYYY-MM-DD"),
        dateTo: moment().endOf("year").format("YYYY-MM-DD"),
      };
      const res = await httpService.post(summarizeLeadUrl, body);
      if (res && res.result && res.result.code === 201) {
        setDataCharts(res.result.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <h4 className="my-0 font-size-18 text-capitalize mb-4">
          Báo cáo khách hàng
        </h4>
        <div className="report-list">
          <Container fluid>
            <Row>
              <Col xl={6} lg={6} xs={12}>
                <Card>
                  <CardBody className="card-body-height">
                    <CardTitle className="mb-5">
                      Số lượng khách hàng mới theo tháng
                    </CardTitle>
                    <BarChartCustomer dataCharts={dataCharts} />
                  </CardBody>
                </Card>
              </Col>
              <Col xl={6} lg={6} xs={12}>
                <Card>
                  <CardBody className="card-body-height">
                    <CardTitle className="mb-5">
                      BC khách hàng theo khu vực
                    </CardTitle>
                    <ProvinceCustomerPieChart dataCharts={dataCharts} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>

          <Spacer size={50} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReportCustomer;
